<template>
  <div>
    <page-heading title="Payroll">
      <div slot="buttons">
      </div>
    </page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-10 text-h-20"></p>
        <p class="text text-50"></p>
        <p class="text text-25"></p>
        <p class="text text-25"></p>
      </el-card>
    </content-placeholder>

    <el-card v-else>
      <div slot="header">
      </div>
      <el-row :gutter="20">
        <el-col :span="10">
        </el-col>
        <el-col :span="14">
          <table>
            <tbody>
              <tr>
                <td>
                  <el-date-picker
                    v-model="selectedDates"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date">
                  </el-date-picker>
                </td>
                <td>
                  <el-button @click="generatePayroll" type="primary">Generate Payroll</el-button>
                </td>  
              </tr>
            </tbody>
          </table>
        </el-col>
        <el-col>
        </el-col>  
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapActions } from 'vuex';
  import XLSX from 'xlsx';
  import { saveAs } from 'file-saver';
  import { forEach } from 'lodash';

  export default {
    name: 'Payroll',
    created() {
      this.fetchPayrolls();
    },
    data() {
      return {
        loading: true,
        selectedDates: moment(),
        weeks: [],
      };
    },
    computed: {
      ...mapGetters('entities/payrolls', ['fetching']),
      ...mapGetters('entities/users', ['currentUser']),

      dateFormatted() {
        return this.selectedDates;
      },
      payrolls() {
        return this.$store.getters['entities/payrolls/query']()
          .with('user')
          .orderBy('date', 'asc')
          .get();
      },
    },
    methods: {
      ...mapActions('entities/payrolls', ['fetchPayrolls', 'exportPayroll']),

      buildParams() {
        return {
          loading: true,
          start_date: this.selectedDates[0].toLocaleDateString('en-us'),
          end_date: this.selectedDates[1].toLocaleDateString('en-us'),
        };
      },

      fetchData() {
        this.fetching = true;
        this.loadError = null;
        this.exportPayroll(this.buildParams())
          .then((response) => {
            this.writeXlsx(response.data);
          });
      },

      writeXlsx(data) {
        const wb = XLSX.utils.book_new();
        wb.Props = {
          Title: 'Staffron Payroll',
        };
        wb.SheetNames.push('Payroll ');
        const startSelectedDate = this.selectedDates[0].toLocaleDateString('en-CA');
        const endSelectedDate = this.selectedDates[1].toLocaleDateString('en-CA');
        const wsData = [[], ['', '', startSelectedDate, '-', endSelectedDate], []];
        wsData.push(['', 'Name', 'Regular Hours', 'PTO', 'Unpaid Time Off', 'Sickness/Wellness', 'Federal Holiday', 'Total']);
        forEach(data, (record) => {
          wsData.push(['', record.name, record.billing, record.pto, record.unpaid, record.sickness, record.holiday, record.total]);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wscols = [{ wch: 25 }, { wch: 25 }, { wch: 15 }, { wch: 10 }, { wch: 20 }, { wch: 20 }, { wch: 15 }]; // "characters"

        ws['!cols'] = wscols;

        wb.Sheets['Payroll '] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        const buf = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < wbout.length; i += 1) {
          view[i] = wbout.charCodeAt(i) & 0xFF;
        }
        const fileName = `${startSelectedDate}_to_${endSelectedDate}_payroll`;
        saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
      },

      generatePayroll() {
        this.fetchData();
      },

      showLoader() {
        if (this.comments.length) {
          this.reloading = true;
        } else {
          this.loading = true;
        }
      },

      hideLoader() {
        this.reloading = false;
        this.loading = false;
      },
    },
  };
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/Payroll.vue